export default {
  setting: {
      wholeNumMessage: "Doit être un nombre entier",
      profileAuthSetting: "Paramètres d'authentification du profil",
      logInOutSetting: "Paramètres de connexion/déconnexion",
      autoLogout: "Déconnexion automatique",
      unsuccessfulLoginAttempt: "Tentatives de connexion échouées",
      unsuccessfulLoginLockPeriod: "Période de verrouillage après tentatives de connexion échouées",
      passCriteriaSetup: "Configuration des critères de mot de passe",
      passLength: "Longueur du mot de passe",
      noUniquePassRequired: "Nombre de mots de passe uniques requis",
      maxPassAge: "Âge maximal du mot de passe",
      acceptableRangeOfChars: "Plage acceptable de caractères",
      upperCase: "Majuscules",
      lowerCase: "Minuscules",
      numbers: "Chiffres",
      specialChars: "Caractères spéciaux",
      uniqueSymbols: "Symboles uniques",
      loadingData: "Chargement des données...",
      currency: "Devise",
      codeActivationTime: "Temps d'activation du code",
      changeGlobalSetting: "Modifier les paramètres globaux",
      globalSetting: "Paramètres globaux",
      generalSetting: "Paramètres généraux",
      hour: "Heures",
      days: "Jours",
      minutes: "Minutes",
      perDay: "Par jour",
      perHour: "Par heure",
      customised: "Personnalisé",
      areaUnit: "Unité de superficie",
      weightUnit: "Unité de poids",
      minimumPwdLen: "Longueur minimale de mot de passe autorisée",
      otpPlaceholder: "Générer un OTP à 6 chiffres",
      generateOTP: "Générer OTP",
      smallFarm: "Petite ferme",
      inclusive: "Inclusif",
      from: "De",
      to: "À",
      mediumFarm: "Ferme moyenne",
      largeFarm: "Grande ferme",
      requiredMessage: "Ce champ est requis",
      nonNegativeMessage: "Ce champ ne doit pas être négatif",
      fieldToGreaterThanFrom: "Ce champ doit être supérieur au champ 'De'",
      fieldToGreaterThanFromMedium: "Ce champ doit être supérieur au champ 'À' de la Petite ferme",
      fieldToGreaterThanMediumTo: "Ce champ doit être supérieur au champ 'À' de la Ferme moyenne",
  },
}
